// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5o-88","titleSpacing":"styles_titleSpacing__LFEH2"};